@switch (fundAllocationStep) {
  @case (fundAllocationSteps.ALLOCATION_STEP_1) {
    <mat-dialog-content class="matDialogContent">
      <h2 class="matDialogTitle">
        {{ fundAllocationTitles.ADD_TO_TOTAL }}
      </h2>
      <p class="matDialogSubtitle">
        {{ fundAllocationTitles.TOTAL_INPUT_SUB }}
      </p>
      <form [formGroup]="fundAllocationForm" class="fundAllocationsForm">
        <mat-form-field
          appearance="outline"
          subscriptSizing="dynamic"
          class="matDialogFormField"
        >
          <mat-label class="matDialogMatLabel">{{
            fundAllocationTitles.ADD_FUNDS_TITLE
          }}</mat-label>
          <input
            type="number"
            matInput
            appAllowNumbersOnly
            class="matDialogInputField"
            formControlName="allocationInput"
          />
        </mat-form-field>
        @if (
          fundAllocationForm.get("allocationInput")?.touched &&
          fundAllocationForm.get("allocationInput")?.hasError("required")
        ) {
          <mat-error>
            *Add funds {{ fundAllocationMessages.REQUIRED }}
          </mat-error>
        }
        @if (
          fundAllocationForm.get("allocationInput")?.touched &&
          fundAllocationForm.get("allocationInput")?.hasError("min")
        ) {
          <mat-error>
            {{ fundAllocationMessages.MIN_AMOUNT }}
            {{ universityMaxAllocationCap.MIN_AMOUNT | customCurrency }}
          </mat-error>
        }
        @if (
          fundAllocationForm.get("allocationInput")?.touched &&
          fundAllocationForm.get("allocationInput")?.hasError("max")
        ) {
          <mat-error>
            {{ fundAllocationMessages.MAX_AMOUNT }}
            {{ universityMaxAllocationCap.MAX_AMOUNT | customCurrency }}
          </mat-error>
        }
      </form>
      <mat-dialog-actions class="matDialogActions">
        <button
          mat-flat-button
          matDialogClose
          (click)="handleCancel()"
          class="matDialogActionButton fundAllocationsPrimaryColorItems"
        >
          {{ fundAllocationButtons.CANCEL }}
        </button>
        <button
          mat-flat-button
          class="matDialogActionButton fundAllocationsPrimaryColorItems"
          [ngClass]="{ enabledButton: fundAllocationForm.valid }"
          [disabled]="!fundAllocationForm.valid"
          (click)="handleNext()"
        >
          {{ fundAllocationButtons.ADD_FUNDS }}
        </button>
      </mat-dialog-actions>
    </mat-dialog-content>
  }
  @case (fundAllocationSteps.ALLOCATION_STEP_2) {
    <mat-dialog-content>
      @if (!splitOrAdd) {
        <section class="matDialogTitleSection">
          <mat-icon
            class="fundAllocationsPrimaryColorItems matDialogTitleSectionItems back"
            (click)="handleBack()"
            >chevron_left</mat-icon
          >
          <h2
            class="matDialogTitle matDialogTitleSectionItems"
            (click)="handleBack()"
          >
            {{ fundAllocationTitles.SPLIT_FUNDS }}
          </h2>
        </section>
        <p class="matDialogSubtitle">
          {{ fundAllocationTitles.SPLIT_FUNDS_SUB }}
        </p>
        <section
          [formGroup]="fundAllocationForm"
          class="mat-dialog-content splitFundsDialogContent"
        >
          <form
            class="fundAllocationsForm"
            formArrayName="universityCheckboxes"
          >
            @for (
              checkboxControl of checkboxesFormArray.controls;
              track checkboxControl;
              let i = $index
            ) {
              <ng-container [formGroupName]="i">
                <mat-checkbox
                  color="primary"
                  class="matDialogCheckbox"
                  formControlName="checkBoxValue"
                >
                  {{ checkboxControl.get("universityName")?.value }}
                </mat-checkbox>
              </ng-container>
            }
          </form>
          @if (universitiesWithCapped.length > 0) {
            <section class="universitiesWithCapFunds">
              @for (university of universitiesWithCapped; track university) {
                <mat-error>
                  *{{ university.name }} is over funds capacity limit by
                  {{ university.amount | customCurrency }}.
                </mat-error>
              }
            </section>
          }
        </section>
        <mat-dialog-actions class="matDialogActions">
          <button
            mat-flat-button
            matDialogClose
            (click)="handleCancel()"
            class="matDialogActionButton fundAllocationsPrimaryColorItems"
          >
            {{ fundAllocationButtons.CANCEL }}
          </button>
          <button
            mat-flat-button
            (click)="handleNext()"
            class="matDialogActionButton fundAllocationsPrimaryColorItems"
            [ngClass]="{
              enabledButton:
                fundAllocationForm.touched && fundAllocationForm.valid
            }"
            [disabled]="
              !(fundAllocationForm.touched && fundAllocationForm.valid)
            "
          >
            {{ fundAllocationButtons.SPLIT_FUNDS }}
          </button>
        </mat-dialog-actions>
      }
      @if (splitOrAdd) {
        <section class="matDialogTitleSection">
          <h2
            class="matDialogTitle matDialogTitleSectionItems"
            (click)="handleBack()"
          >
            {{ fundAllocationTitles.SPLIT_FUNDS_ADD }}
          </h2>
        </section>
        <p class="matDialogSubtitle">
          {{ fundAllocationTitles.PERMISSIONS }}
        </p>
        <mat-dialog-actions class="matDialogActions">
          <button
            mat-flat-button
            matDialogClose
            (click)="handleCancel()"
            class="matDialogActionButton fundAllocationsPrimaryColorItems"
          >
            {{ fundAllocationButtons.CANCEL }}
          </button>
          <section class="splitOrAdd">
            <button
              mat-flat-button
              (click)="handleAddToTotal()"
              class="matDialogActionButton fundAllocationsPrimaryColorItems"
              [disabled]="
                !(fundAllocationForm.touched && fundAllocationForm.valid)
              "
            >
              {{ fundAllocationButtons.ADD_TO_TOTAL_FUNDS }}
            </button>
            <button
              mat-flat-button
              (click)="handleNext()"
              class="matDialogActionButton fundAllocationsPrimaryColorItems splitFunds"
              [ngClass]="{
                enabledButton:
                  fundAllocationForm.touched && fundAllocationForm.valid
              }"
              [disabled]="
                !(fundAllocationForm.touched && fundAllocationForm.valid)
              "
            >
              {{ fundAllocationButtons.SPLIT_FUNDS }}
            </button>
          </section>
        </mat-dialog-actions>
      }
    </mat-dialog-content>
  }
  @case (fundAllocationSteps.CONFIRM_ALLOCATION) {
    <mat-dialog-content>
      <section class="matDialogTitleSection">
        <mat-icon
          class="fundAllocationsPrimaryColorItems matDialogTitleSectionItems"
          (click)="handleBack()"
          >keyboard_arrow_left</mat-icon
        >
        <h2
          class="matDialogTitle matDialogTitleSectionItems"
          (click)="handleBack()"
        >
          {{ fundAllocationTitles.CONFIRM_SPLIT }}
        </h2>
      </section>
      <p class="matDialogSubtitle">
        {{ fundAllocationTitles.CONFIRM_SPLIT_SUB }}
      </p>
      <section class="universitiesToSplitFunds">
        <p class="allocateToFrom totalFundsAdded">
          {{ fundAllocationTitles.TOTAL_FUNDS_ADDED }}
        </p>
        <p class="allocateToFrom totalFundsAdded totalFundsAddedAmount">
          {{ fundAllocationForm.value.allocationInput | customCurrency }}
        </p>
      </section>
      <mat-divider class="allocationsMatDivider"></mat-divider>
      @for (university of universitiesToSplitMoney; track university) {
        <section class="universitiesToSplitFunds totalFundsAdded">
          <p class="allocateToFrom university">{{ university }}:</p>
          <p class="allocateToFrom totalFundsAdded">
            {{ allocationMoney | customCurrency }}
          </p>
        </section>
      }
      <mat-dialog-actions class="matDialogActions">
        <button
          mat-flat-button
          matDialogClose
          (click)="handleCancel()"
          class="matDialogActionButton fundAllocationsPrimaryColorItems"
        >
          {{ fundAllocationButtons.CANCEL }}
        </button>
        <button
          mat-flat-button
          (click)="handleConfirm()"
          class="matDialogActionButton fundAllocationsPrimaryColorItems"
          [ngClass]="{
            enabledButton:
              fundAllocationForm.touched &&
              fundAllocationForm.valid &&
              universitiesWithCapped.length === 0 &&
              universitiesToSplitMoney.length > 0
          }"
          [disabled]="
            !(
              fundAllocationForm.get('universityCheckboxes')?.valid &&
              universitiesWithCapped.length === 0 &&
              universitiesToSplitMoney.length > 0
            )
          "
        >
          {{ fundAllocationButtons.CONFIRM }}
        </button>
      </mat-dialog-actions>
    </mat-dialog-content>
  }
}
